const styles = {
  message: {
    color: 'kit.text.mainInverse',
    marginBottom: '8px',
    fontSize: {
      xl: '14px',
      lineHeight: '20px',
    },
  },
  textFieldBlock: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginBottom: '16px',
    alignItems: 'flex-start',
    flexDirection: {
      xs: 'column',
      xl: 'row',
    },
    '& .MuiFormHelperText-root': {
      position: 'absolute',
      bottom: 0,
      transform: 'translateY(100%)',
      paddingTop: '4px',
      fontSize: '13px',
      lineHeight: '21px',
      color: 'kit.text.mainInverse',
    },
    '& .MuiFormHelperText-root.Mui-error': {
      color: 'kit.text.mainInverse',
    },
  },
  textFieldWrapper: {
    width: '100%',
    fontFamily: 'Inter',
    marginBottom: {
      xs: '24px',
      xl: '14px',
    },
    maxWidth: {
      xs: '350px',
      xl: '200px',
    },
  },
  input: {
    width: '100%',
  },
  submit: {
    textTransform: 'uppercase',
    marginTop: {
      xs: '0',
      xl: '16px',
    },
    marginLeft: {
      xl: '24px',
    },
    '&:disabled': {
      opacity: 0.7,
      color: 'kit.text.mainInverse',
    },
  },
  subscribedMessage: {
    maxWidth: {
      xs: '60%',
      md: '100%',
    },
  },
  subscribed: {
    color: '#ffffff !important',
    maxWidth: {
      xs: '139px',
      md: '40px',
    },
    marginBottom: {
      xs: '40px',
      md: 0,
    },
    marginTop: {
      xs: '75px',
      md: '24px',
    },
  },
  agreement: {
    color: 'rgba(255, 255, 255, 0.7)',
    display: 'flex',
    alignItems: {
      xs: 'flex-start',
      md: 'center',
    },
    flexDirection: {
      xs: 'column',
      md: 'row',
    },
  },
};

export default styles;
